import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { ListingGroup, OrderedListing, Section, SectionVersion } from "lib/data/model";


export class OrderedListingApi {

	public static getAll = async (section: Section, version: SectionVersion, group: ListingGroup, cascade: boolean = false): Promise<OrderedListing[]> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Version/${version.id}/ListingGroup/${group.id}/OrderedListing`;

			// Initialize Parameters
			const parameters: any = {};

			// Check Record Cascading
			if (cascade) {

				// Set To Cascade
				parameters.all = true;
			}

			// Make Request
			const response: Response = await Http.httpGet(url, parameters);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const listingGroups: OrderedListing[] = await ApiHelper.parseResponseBody(response);

				return listingGroups;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return [];
	}

	public static getOne = async (
		section: Section,
		version: SectionVersion,
		group: ListingGroup,
		listingId: number,
		cascade: boolean = false
	): Promise<OrderedListing | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Version/${version.id}/ListingGroup/${group.id}/OrderedListing/${listingId}`;

			// Initialize Parameters
			const parameters: any = {};

			// Check Record Cascading
			if (cascade) {

				// Set To Cascade
				parameters.all = true;
			}

			// Make Request
			const response: Response = await Http.httpGet(url, parameters);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const listingGroup: OrderedListing = await ApiHelper.parseResponseBody(response);

				return listingGroup;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static save = async (section: Section, group: ListingGroup, listing: OrderedListing): Promise<OrderedListing | undefined> => {

		// Initialize Returned Listing Group
		let returnedListingGroup: OrderedListing | undefined;

		// Check Listing Group ID
		if (listing.id !== undefined) {

			// Update Existing Listing Group
			returnedListingGroup = await OrderedListingApi.update(section, group, listing);
		}
		else {

			// Create New Listing Group
			returnedListingGroup = await OrderedListingApi.create(section, group, listing);
		}

		// Return Listing Group
		return returnedListingGroup;
	}

	public static create = async (section: Section, group: ListingGroup, listing: OrderedListing): Promise<OrderedListing | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Draft/ListingGroup/${group.id}/OrderedListing`;

			// Make Request
			const response: Response = await Http.httpPost(url, listing);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const createdListingGroup: OrderedListing = await ApiHelper.parseResponseBody(response);

				return createdListingGroup;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static update = async (section: Section, group: ListingGroup, listing: OrderedListing): Promise<OrderedListing | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Draft/ListingGroup/${group.id}/OrderedListing/${listing.id}`;

			// Make Request
			const response: Response = await Http.httpPut(url, listing);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const updatedListingGroup: OrderedListing = await ApiHelper.parseResponseBody(response);

				return updatedListingGroup;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static delete = async (section: Section, group: ListingGroup, listing: OrderedListing): Promise<boolean> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Draft/ListingGroup/${group.id}/OrderedListing/${listing.id}`;

			// Make Request
			const response: Response = await Http.httpDelete(url, undefined);

			// Return Whether Successful
			return response.ok;

			// TODO: Handle Errors
		}

		// Return Failed
		return false;
	}
}
